uniform float uTime;
varying float uSize;
attribute float aSize;

void main(){

    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

    gl_Position = projectedPosition;

    gl_PointSize = (sin((uTime * 0.0005 + aSize * 50.0) + aSize * 50.0) + 0.8) * 30.0;
    // Size attenuation for perspective camera (though user is using orthographic, it's good practice)
    gl_PointSize *= (1.0 / - viewPosition.z);
    uSize = aSize;

}